export default {
  职员: '网址',
  网址: '网址',
  职称: '职称',
  官网: '官网',
  营业期限: '营业期限',
  组织机构代码: '组织机构代码',
  纳税人识别号: '纳税人识别号',
  核准日期: '核准日期',
  当前位置: '当前位置',
  已选条件: '已选条件',
  已选国内数据: '已选国内数据',
  已选国际数据: '已选国际数据',
  邮件邀约: '邮件邀约',
  短信邀约: '短信邀约',
  '我的客户库（默认）': '我的客户库（默认）',
  创建群组: '创建群组',
  新建群组: '新建群组',
  请选择客户库群组: '请选择客户库群组',
  一键添加客户库: '一键添加客户库',
  已选数据: '已选数据',
  当前共: '当前共',
  '请输入公司名称/经营范围': '请输入公司名称/经营范围',
  关键词: '关键词',
  标签筛选: '标签筛选',
  国内云数据: '国内云数据',
  '国际（港澳台）云数据': '国际（港澳台）云数据',
  语言: '语言',
  搜索范围: '搜索范围',
  省份地区: '省份地区',
  热门: '热门',
}
